import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/userGroupAndPm`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/userGroupAndPm`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/userGroupAndPm`;
